export const deClientPortalValuationPageLayout = {
    sectionLabel: 'BEWERTUNG',
}
